// src/components/exam-player/renderers/McqMultiRenderer.jsx
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

export default function McqMultiRenderer({
  item,
  onAnswerChange,
  initialAnswers,
  questionNumber,
}) {
  const { t } = useTranslation();
  const correctCount =
    typeof item?.body?.correctCount === "number"
      ? item.body.correctCount
      : Infinity;

  const options = Array.isArray(item?.body?.options) ? item.body.options : [];

  // مقدار اولیه: می‌تونه آرایه ساده یا {selected: []} باشه
  const initialSelected = useMemo(() => {
    if (!initialAnswers) return [];
    if (Array.isArray(initialAnswers)) return initialAnswers;
    if (Array.isArray(initialAnswers?.selected)) return initialAnswers.selected;
    return [];
  }, [initialAnswers]);

  const [selected, setSelected] = useState(new Set(initialSelected));

  useEffect(() => {
    setSelected(new Set(initialSelected));
  }, [initialSelected]);

  const toggle = (key) => {
    const next = new Set(selected);

    if (next.has(key)) {
      next.delete(key);
    } else {
      if (next.size >= correctCount) {
        // ❌ بیشتر از حد مجاز
        return;
      }
      next.add(key);
    }

    setSelected(next);
    onAnswerChange?.({ selected: Array.from(next) });
  };
  return (
    <div className="space-y-3">
      {/* شماره سؤال */}
      {typeof questionNumber === "number" && (
        <div
          aria-hidden
          className="inline-flex h-6 min-w-6 items-center justify-center rounded-full border text-xs font-medium px-2"
        >
          {questionNumber}
        </div>
      )}

      <ul className="space-y-2">
        {options.map((opt, idx) => {
          const key = opt?.key ?? String(idx);
          const label =
            opt?.label?.fa ||
            opt?.label?.en ||
            t("preview.option") + ` ${idx + 1}`;
          const checked = selected.has(key);

          return (
            <li key={key} className="flex items-start gap-2">
              <input
                type="checkbox"
                className="mt-1 h-4 w-4 text-purple-600 focus:ring-purple-500"
                checked={checked}
                onChange={() => toggle(key)}
                aria-label={label}
              />
              <label
                className={`text-sm cursor-pointer select-none ${
                  checked ? "font-medium" : ""
                }`}
                onClick={() => toggle(key)}
              >
                {label}
              </label>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
